import styled, { StyledComponent } from '@emotion/styled';
import tw from 'twin.macro';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Text: StyledComponent<{}> & any = styled.span`
  ${tw`font-normal font-body text-color-input-field`}
`;

Text.title = styled(Text.withComponent('h1'))`
  ${tw`font-title font-light leading-none text-3xl`}
`;

Text.headline = styled(Text.withComponent('h2'))`
  ${tw`font-title text-xl`}
`;

Text.subhead = styled(Text.withComponent('h2'))`
  ${tw`text-lg`}
`;

Text.subtitle = styled(Text.withComponent('h2'))`
  ${tw`font-title`}
`;

Text.body = styled(Text.withComponent('div'))`
  ${tw`text-base`}
`;

Text.note = styled(Text.withComponent('div'))`
  ${tw`text-sm font-title`}
`;

Text.link = styled(Text.withComponent('span'))`
  ${tw`text-sm`}
`;

export default Text;
